import _extends from 'babel-runtime/helpers/extends';

import MindNode from './Node.vue';
import _animateScrollTo from 'animated-scroll-to';

export default {
  props: {
    tree: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    removeNode: {
      type: Function,
      default: function _default() {}
    },
    appendChild: {
      type: Function,
      default: function _default() {}
    },
    editNode: {
      type: Function,
      default: function _default() {}
    },
    nameMaxLen: {
      type: Number,
      default: 20
    },
    maxLevel: {
      type: Number,
      default: Infinity
    }
  },

  components: {
    MindNode: MindNode
  },

  data: function data() {
    return {
      width: '100%',
      currentNode: {
        id: ''
      },
      scale: 1
    };
  },


  watch: {
    tree: {
      handler: function handler(val) {
        this.updateLayout();
      },

      deep: true
    }
  },

  mounted: function mounted() {},


  methods: {
    updateLayout: function updateLayout() {
      var _this = this;

      this.$nextTick(function () {
        var nodes = document.querySelectorAll('.mind-node.root-node > .mind-node-children > .mind-node');
        var width = 0;
        nodes.forEach(function (node) {
          width += node.offsetWidth;
        });
        _this.width = width + 40 + 'px';
      });
    },
    updateCurrentNode: function updateCurrentNode(currentNode) {
      this.currentNode = _extends({}, currentNode);
    },
    handleScaleChange: function handleScaleChange(value) {
      this.updateLayout();
    },
    alignCenter: function alignCenter() {
      var container = this.$refs['mind-map-container'];
      var rootNode = container.querySelector('.root-node .mind-node-text');
      var halfOfContainer = container.offsetWidth / 2;
      var quarterOfRootNode = rootNode.offsetWidth / 4;
      // 滚动到中间
      _animateScrollTo([rootNode.offsetLeft - quarterOfRootNode - halfOfContainer, null], {
        elementToScroll: container.querySelector('.mind-map')
      });
    },
    animateScrollTo: function animateScrollTo(id) {
      var container = this.$refs['mind-map-container'];
      var currentNode = container.querySelector('#mind-node-' + id);
      // 横向滚动
      _animateScrollTo(currentNode, {
        elementToScroll: container.querySelector('.mind-map')
      });
    }
  }
};